import Vue from "vue";
import Router from "vue-router";
import Meta from "vue-meta";
import store from "./store";

const originalPush = Router.prototype.push;

Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }

  return originalPush.call(this, location).catch((error) => {
    if (error.message.includes("Avoided redundant navigation")) {
      return;
    }

    return Promise.reject(error);
  });
}

import {
  cookiesAreSupported,
  setCookie,
  REMAINING_PAGE_VIEWS,
  getRemainingPageViews,
} from "@/mixins/cookies";

Vue.use(Router);
Vue.use(Meta);

const routes = [
    {
      path: "/login",
      component: () => import("./pages/Login"),
      meta: {
        auth: false,
      },
    },
    {
      path: "/email-verified",
      component: () => import("./pages/EmailVerified"),
    },
    {
      path: "/about",
      component: () => import("./pages/About"),
    },
    {
      path: "/methodology",
      component: () => import("./pages/Methodology"),
    },
    {
      path: "/data-dictionary",
      component: () => import("./pages/DataDictionary"),
    },
    {
      path: "/senate",
      component: () => import("./pages/SenateLanding"),
    },
    {
      path: "/house",
      component: () => import("./pages/HouseLanding"),
    },
    {
      path: "/enable-cookies",
      component: () => import("./pages/EnableCookies"),
    },
    {
      alias: "/house/:raceID",
      path: "/senate/:raceID",
      component: () => import("./pages/Race/RacePage"),
    },
    {
      path: "/president",
      redirect: "/senate",
    },
    {
      path: "*",
      redirect: "/senate",
    },
]

const router = new Router({
    mode: "history",
    routes,
    scrollBehavior() {
        return {x: 0, y: 0};
    },
});

const pathsToSkipPageCount = [
  "/login",
  "/enable-cookies",
];

router.beforeEach((to, from, next) => {
    if (!cookiesAreSupported()) return "/enable-cookies";

    const loggedIn = Vue.$auth.token || Vue.$auth.authenticated;

    if (!pathsToSkipPageCount.includes(to.path)) {
      if (!loggedIn) {
        const remainingViews = getRemainingPageViews();

        if (remainingViews <= 0 && !to.hash.startsWith("#access_token")) {
          next("/login");
          return;
        }

        setCookie(REMAINING_PAGE_VIEWS, remainingViews - 1);
      }
    }

    store.dispatch("ux/cancelPendingRequests");

    if (to.hash.startsWith("#access_token") === true) {
      const RE = /access_token=(.[^&]*)&/;
      const token = to.hash.match(RE)[1];
      Vue.$auth.login(token);
    }

    const redirect = to.query.redirect;
    if (typeof redirect !== "undefined") {
      const parts = redirect
        .replace(window.location.origin, "")
        .split("/")
        .filter(v => v);

      if (parts.length === 2) {
        next(`/${parts[0]}/${parts[1]}`);
      } else {
        next();
      }
    } else if (
      to.path === "/login" &&
      loggedIn
    ) {
      next("/");
    } else {
      next();
    }
});

export default router;
